import { render } from "./ContentblockReadFurther.vue?vue&type=template&id=78399515&scoped=true&ts=true"
import script from "./ContentblockReadFurther.ts?vue&type=script&lang=ts"
export * from "./ContentblockReadFurther.ts?vue&type=script&lang=ts"

import "./ContentblockReadFurther.scss?vue&type=style&index=0&id=78399515&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78399515"]])

export default __exports__